import styled from 'styled-components'

import { PairInformationShort } from '@root/features/pair/ui'
import { QuickBuyButton } from '@root/features/trade/swap/ui/desktop'

import { TrackedWalletSquareTable } from './tracked-wallet-square-table'

import type { PairModel } from '@root/entities/pair'
import type { WalletAddress } from '@root/entities/wallet'

type TrackedWalletSquareProps = {
  pair: PairModel
  makerAddress: WalletAddress
}

export const TrackedWalletSquare: React.FC<TrackedWalletSquareProps> = ({
  pair,
  makerAddress,
}) => {
  return (
    <Root>
      <PairInformationShort pair={pair} />
      <TrackedWalletSquareTable pair={pair} makerAddress={makerAddress} />
      <Footer>
        <QuickBuyButton
          pair={pair}
          withIcon
          withLabel
          section="walletsTracker"
        />
      </Footer>
    </Root>
  )
}

const Root = styled.div`
  border-radius: 10px;
  background: var(--appearance-1);

  display: grid;
  grid-template-rows: auto 1fr auto;

  height: 350px;
  width: 100%;
`

const Footer = styled.div`
  border-top: 1px solid var(--background-2);

  justify-items: end;
  display: grid;
  align-items: center;

  height: 44px;
  padding-inline: 12px;
`
